export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 14 Mall Closed.b29da674.mp3";